export default "__VITE_ASSET__DATjttxR__"